'use strict';

// Small Subset of timezones to provide an offline safetynet
const DEFAULT_TIMEZONES = [
  {
    value: 1,
    name: 'Coordinated Universal Time',
    displayName: 'Coordinated Universal Time'
  },
  {
    value: 78,
    name: 'Eastern Standard Time',
    displayName: 'Eastern Time (US & Canada)'
  }
];

const availableTimeZones = state => {
  return state.availableTimeZones;
};

const defaultTimeZone = state => {
  const availableTimeZones = state.availableTimeZones || DEFAULT_TIMEZONES;
  const currentDefaultTimeZone = state.defaultTimeZone || 'Eastern Standard Time';
  return availableTimeZones.find(timeZone => timeZone.name === currentDefaultTimeZone);
};

// Legacy application timezones.  Can be eliminated in future release.
const availableApplicationTimeZones = state => [...state.availableApplicationTimeZones];

const availableAgentStates = state => [...state.availableAgentStates];

const availableCustomBreakStates = state => [...state.availableCustomBreakStates];

const availableInteractionHistoryPeriods = state => [...state.availableInteractionHistoryPeriods];

const availableIdleTimesToAgentIntelligenceCenter = state => [...state.availableIdleTimesToAgentIntelligenceCenter];

const availableAlertsEndOfBreak = state => [...state.availableAlertsEndOfBreak];

const availableLanguages = state => [...state.availableLanguages];

const availableTimeFormats = state => [...state.availableTimeFormats];

const availableIncomingInteractionDisplayModes = state => [...state.availableIncomingInteractionDisplayModes];

const availableIncomingInteractionRingtones = state => {
  const sortByLabel = (r1, r2) => {
    const fallbackSort = r1.label < r2.label ? -1 : 0;
    return r1.label > r2.label ? 1 : fallbackSort;
  };
  return [...state.availableIncomingInteractionRingtones].sort(sortByLabel);
};

const getSmtpDetails = state => bpId => {
  let bpSettings = state.smtpDetails.businessProcesses.find(bp => bp.id === bpId);
  if (!bpSettings) {
    bpSettings = {
      alternateBPFromEmailAddressAliases: [],
      defaultBPFromEmailAddress: '',
      overrideBCCEmailAddress: ''
    };
  }
  return {
    defaultBccEmailAddress: state.smtpDetails.defaultBccEmailAddress,
    defaultFromEmailAddress: state.smtpDetails.defaultFromEmailAddress,
    alternateBPFromEmailAddressAliases: bpSettings.alternateBPFromEmailAddressAliases,
    defaultBPFromEmailAddress: bpSettings.defaultBPFromEmailAddress,
    overrideBCCEmailAddress: bpSettings.overrideBCCEmailAddress,
    outgoingEmailMode: state.smtpDetails.outgoingEmailMode
  };
};

const getBusinessProcessDefaultFromEmail = state => bpId => {
  if (state.smtpDetails.outgoingEmailMode === 0) {
    return null;
  }
  const bpSettings = state.smtpDetails.businessProcesses.find(bp => bp.id === bpId);

  if (!bpSettings) {
    return state.smtpDetails.defaultFromEmailAddress;
  }

  return bpSettings.defaultBPFromEmailAddress !== ''
    ? bpSettings.defaultBpFromEmailAddress
    : state.smtpDetails.defaultFromEmailAddress;
};

const isSmtpEnabled = state => state.smtpDetails.outgoingEmailMode === 1;

const getSmsDetails = state => bpId => {
  return state.smsDetails.filter(did => did.handlerId === bpId);
};

const getBusinessProcessesDIDs = state => bpId => {
  const businessProcess = state.smtpDetails.businessProcesses.find(bp => bp.id === bpId);

  if (!businessProcess) {
    return [];
  }

  return businessProcess.outgoingDIDs;
};

const valueSets = state => state.valueSets;

const supervisorKPIsDescription = state => [...state.supervisorKPIsDescription];

export default {
  availableTimeZones,
  defaultTimeZone,
  availableApplicationTimeZones,
  availableAgentStates,
  availableCustomBreakStates,
  availableInteractionHistoryPeriods,
  availableIdleTimesToAgentIntelligenceCenter,
  availableAlertsEndOfBreak,
  availableLanguages,
  availableTimeFormats,
  availableIncomingInteractionDisplayModes,
  availableIncomingInteractionRingtones,
  getSmtpDetails,
  getSmsDetails,
  isSmtpEnabled,
  getBusinessProcessDefaultFromEmail,
  getBusinessProcessesDIDs,
  valueSets,
  supervisorKPIsDescription
};
